import React, { useRef } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch } from "react-icons/fa";

const CustomDataTable = ({
  ref,
  columns,
  data = [],
  enableSearch = false,
  search,
  setSearch,
  serverPagenation = false,
  conditionalRowStyles = [],
  paginationTotalRows,
  handleChangePage,
  handleRowsChange,
  onSelectedRowsChange = false,
  selectableRows,
  selectableRowDisabled,
  pagination = true,
  fixedHeaderScrollHeight = '59vh',
  clearSelectedRows,
  isMultiSelect= true
}) => {
  const customStyles = {
    rows: {
      style: {
        // fontSize: "0.875rem",
        // padding: "12px 16px",
        // backgroundColor: "#F3F4F6",
        // borderBottom: "1px solid #E5E7EB",
        backgroundColor: "white",
        borderBottom: "1px solid #e5e7eb",
      },
    },
    headCells: {
      style: {
        // fontSize: "0.875rem",
        // fontWeight: "bold",
        // backgroundColor: "#F3F4F6",
        // color: "black",
        // padding: "12px 16px",
        // borderBottom: "2px solid #D1D5DB",
        // margin: 0,
          textAlign: "left",
          paddingTop: "0.75rem", // py-3
          paddingBottom: "0.75rem", // py-3
          paddingLeft: "1rem", // px-4
          paddingRight: "1rem", // px-4
          fontSize: "0.875rem", // text-sm
          fontWeight: "600", // font-semibold
          color: "black",
          backgroundColor:"#f1f5f9", // text-gray-600        
      },
    },
    cells: {
      style: {
        fontSize: "0.875rem",
        overflow: "hidden",
        color: "gray-800"
      },
    },
    pagination: {
      style: {
        fontSize: "0.875rem",
        backgroundColor: "#f1f5f9", // bg-slate-100
        color: "black",
        borderTop: "1px solid #D1D5DB", // Ensure proper border styling
        overflow: "hidden",
        borderBottomLeftRadius: "8px", // Rounded bottom-left corner
        borderBottomRightRadius: "8px", // Rounded bottom-right corner
      },
    },
  };

  const handlePageChange = (page) => {
    handleChangePage(page - 1);
  };

  const handleRowsPerPage = (rowsPerPage) => {
    handleRowsChange(rowsPerPage);
  };

  return (
    <div className="space-y-6">
       <div className="bg-slate-100  pt-1">
       {enableSearch && (
        // <div className="flex items-center w-full max-w-md px-4 py-2 mb-4 border rounded-lg shadow-sm mt-3 ml-4">
        // <div className='relative w-full'>
        <div className = "relative flex w-1/2 sm:w-3/4 md:w-2/3 lg:w-1/2 xl:w-1/3">
          <input
            // className="w-full text-sm border-none outline-none"\
            className='w-full pl-10 py-2 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-cyan-800 focus:border-transparent'
            placeholder="Search by Name"
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {/* <FaSearch className="absolute left-3 top-2.5 h-5 w-5 text-slate-400" /> */}
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-slate-400" />
        </div>
      )}
      
    </div>
    <div className="overflow-x-scroll rounded-t-lg no-scrollbar">
       <DataTable
       ref={ref}
        columns={columns}
        data={data}
        pagination={pagination}
        paginationServer={serverPagenation}
        striped
        highlightOnHover
        customStyles={customStyles}
        paginationTotalRows={paginationTotalRows}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPage}
        // className={"border border-gray-200 rounded-lg overflow-hidden shadow-md shadow-gray-400"}
        paginationRowsPerPageOptions={[  5, 10, 15, 20, 25, 30, 35]}
        fixedHeader
        fixedHeaderScrollHeight={fixedHeaderScrollHeight}
        conditionalRowStyles={conditionalRowStyles && conditionalRowStyles}
        onSelectedRowsChange={selectableRows && onSelectedRowsChange}
        selectableRows={selectableRows}
        clearSelectedRows={clearSelectedRows} // Pass to react-data-table-component
        selectableRowDisabled={selectableRowDisabled}
        selectableRowsSingle={isMultiSelect}
        selectableRowsHighlight={!isMultiSelect}
      />
      </div>
    </div>
  );
};
CustomDataTable.defaultProps = {
  data: [],
};

export default CustomDataTable;
